module.exports = __webpack_public_path__ + "img/kununu.2581d1d7.png";